import { Component, OnInit } from '@angular/core';
import { IonNav, Platform } from '@ionic/angular';

@Component({
  selector: 'app-cookies-info',
  templateUrl: './cookies-info.component.html',
  styleUrls: ['./cookies-info.component.scss'],
})
export class CookiesInfoComponent implements OnInit {

  constructor(private platform: Platform, private nav: IonNav) { }

  get isWeb() {
    return ! this.platform.is('capacitor');
  }

  ngOnInit() {}

  goBack() {
    this.nav.pop();
  }

}
